import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import TourCard from "./TourCard";
import DayTours from "./DayTours";
import RoundTours from "./RoundTours";
import rt from "../accests/common/rt.jpg";
import tt from "../accests/common/tt.jpg";
import ttt from "../accests/common/ab.jpeg";

export default function Tours() {
    const [selectedTour, setSelectedTour] = useState(null); // null | "day" | "round"

    const tourData = [
        {
            title: "Day Tours",
            image: rt,
            key: "day",
        },
        {
            title: "Round Tours",
            image: tt,
            key: "round",
        },
    ];

    const getTourComponent = () => {
        if (selectedTour === "day") return <DayTours />;
        if (selectedTour === "round") return <RoundTours />;
        return null;
    };

    return (
        <>
            {/* HERO SECTION */}
            <section className="relative h-80 flex items-center justify-center">
                <img
                    src={ttt}
                    className="absolute inset-0 w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-black/50"></div>
                <motion.h1
                    initial={{opacity: 0, y: 30}}
                    animate={{opacity: 1, y: 0}}
                    transition={{duration: 1}}
                    className="relative text-4xl md:text-5xl font-bold text-white mt-20 text-center"
                >
                    Our Tour Packages

                    <h4 className="text-xl  mt-5 text-center mb-12">
                        From golden beaches to ancient heritage, experience Sri Lanka like never before.
                    </h4>
                </motion.h1>
            </section>

            {/* TOUR CARDS */}
            <section className="py-20 px-6 bg-gray-100">


            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
                    {tourData.map((tour) => (
                        <TourCard
                            key={tour.key}
                            title={tour.title}
                            image={tour.image}
                            onClick={() => setSelectedTour(tour.key)}
                        />
                    ))}
                </div>
            </section>

            {/* MODAL */}
            <AnimatePresence>
                {selectedTour && (
                    <motion.div
                        key="modal"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        className="fixed inset-0 z-50 flex items-center justify-center bg-black/70"
                    >
                        <motion.div
                            initial={{ scale: 0.8 }}
                            animate={{ scale: 1 }}
                            exit={{ scale: 0.8 }}
                            transition={{ duration: 0.3 }}
                            className="bg-white rounded-2xl shadow-xl max-w-4xl w-full p-6 relative overflow-y-auto max-h-[90vh]"
                        >
                            {/* Close Button */}
                            <button
                                onClick={() => setSelectedTour(null)}
                                className="absolute top-4 right-4 text-gray-600 hover:text-gray-900 text-2xl font-bold"
                            >
                                &times;
                            </button>

                            {/* Tour Content */}
                            {getTourComponent()}
                        </motion.div>
                    </motion.div>
                )}
            </AnimatePresence>
        </>
    );
}
